import Backbone from 'backbone'
import _ from 'lodash'
import DashboardData from './dashboard-data'
import sections from 'scoreboard/components/sections'
import permissions from 'scoreboard/components/permissions'
import { SnapType } from 'canvas/lib/support/snap'

var Dashboard = Backbone.Model.extend({
	section: 'dashboards',
	domainType: 'dashboard',

	defaults: {
		snapType: SnapType.WIDGETS
	},

	urlRoot: function(options) {
		return 'api/' + sections.toUrl(this.section)
	},

	isEditable: function() {
		return permissions.dashboards(this.get('organizationId')) && permissions.isEditableIfReplicated(this)
	},

	parse: function (response) {
		response.data && this.data.set(response.data)
		return response
	},

	initialize: function (attr) {
		attr = attr || {}
		this.data = new DashboardData({
			data: attr.data,
			fetchOptions: function (opt) {
				let data = {
					liveFilters: this.maestro.liveFilters(),
					drilldownIdsByFieldId: this.maestro.drilldownIdsByFieldId()
				}

				var url = 'api/dashboards/data?calendarPeriodId=' + opt.periodId
				if (!this.isNew()) {
					url += '&dashboardId=' + this.id
				}

				return {
					type: 'POST',
					url: url,
					data: JSON.stringify(data)
				}
			}.bind(this)
		})
	},

	wobData: function () {
		var data = this.data.get()

		return _.map(this.get('widgets'), function (n) {
			var wob = _.omit(n, 'properties', 'zindex', 'rotation')
			wob['z-index'] =  n.zindex
			wob['rotate'] =  n.rotation
			if (n.hasTemplate) {
				wob.locked = true
			}

			var widget = {
				type: n.properties.type,
				data: data,
				properties: n.properties,
				wob: wob
			}

			wob.connectors = wob.connectors || []
			wob.connectors.forEach(connector => _.extend(connector,{
				from: connector.fromId,
				to: connector.toId,
				style: {
					opacity: connector.opacity,
					'stroke-dasharray': connector.strokeDasharray,
					'stroke-width': connector.strokeWidth
				},
				readonly: !!connector.templateConnectorId
			}))

			return _.extend({
				widget: widget
			}, wob)
		})
	}

})

export default Dashboard

Dashboard.__filename__ = 'dashboards/dashboard.js'
